import axiosApi, { setHeader } from "api/root.api";

export const sendFeedback = async (body, token) => {
  const urlEnd = "/platform/feeedback/v1/cancelReason";
  setHeader("Authorization", `Bearer ${token}`);
  const response = await axiosApi.post(urlEnd, body);
  const result = response.data;
  return result;
};
